import React from 'react'
import PackageComponent from '../../Package'
import { Home_Origin } from '../../../utils/formatType'

export default function OriginPage() {
  return (
    <div>
      <PackageComponent title="Nguồn hàng" packageId={Home_Origin} />
    </div>
  )
}
